import useMediaQuery from '@mui/material/useMediaQuery';
import { Box, Stack } from '@mui/material';

import Profile from './Profile';
import MobileSection from './MobileSection';
import Notification from './Notification';

export default function HeaderContent() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  return (
    <>
      {!downLG && (
        <Stack direction="row" alignItems="center" sx={{ ml: 'auto' }} spacing={1}>
          <Notification />
          <Profile />
        </Stack>
      )}

      {downLG && <MobileSection />}
    </>
  );
}
